import oboe from 'oboe'
import semver from 'semver'

import Events from './bus.js'

var releasesUrl = './releases/releases.json';
var sdks = ['common', 'knowledge', 'case', 'chat', 'sos'];
var releases = {};
var latest = {};

var readReleases = function () {
  oboe(releasesUrl).done(data => {
    sdks.forEach(sdk => {
      data.filter(release => {
          if (!releases[release.sdk]) {
            console.log("allocating " + release.sdk);
            releases[release.sdk] = {};
          }

          return release.sdk === sdk;
        })
        .map(release => {
          releases[sdk][release.version] = release;
          return release;
        });
    });

    console.info("Loaded releases", releases);
    Events.$emit('releasesLoaded', releases);
    findLatestReleases();
  });
}();

var findLatestReleases = function () {
  sdks.forEach(sdk => {
    if (!releases[sdk]) {
      return;
    }
    var version = semver.maxSatisfying(Object.keys(releases[sdk]), '>0.0.0');
    console.debug('latest ' + sdk, version);
    latest[sdk] = releases[sdk][version];
  });

  console.log("Latest releases ", latest);
  Events.$emit('latestReleases', latest);
};

export {
  releases, latest, findLatestReleases
}



// WEBPACK FOOTER //
// ./src/ReleaseLoader.js